// extracted by mini-css-extract-plugin
module.exports = {"svg-loading":"loading-icon__svg-loading___jR4Li","spin":"loading-icon__spin___1U9ea"};